

















































import { Emit, Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import CalculateStore from '@/stores/CalculateStore'
import FromShipmentPointSelect from '@/components/calculator/CalculatorForm/FromShipmentPointSelect.vue'
import ToCountrySelect from '@/components/calculator/CalculatorForm/ToCountrySelect.vue'
import PlaceSelect from '@/components/calculator/CalculatorForm/PlaceSelect/PlaceSelect.vue'
import WeightField from '@/components/calculator/CalculatorForm/WeightField.vue'
import PriceField from '@/components/calculator/CalculatorForm/PriceField.vue'
import DimensionsField from '@/components/calculator/CalculatorForm/DimensionsField.vue'
import Country from '@/dto/deliveries/Country'
import ErrorMessages from '@/components/calculator/CalculatorForm/ErrorMessages.vue'

@Component({
  components: {
    ErrorMessages,
    DimensionsField,
    PriceField,
    WeightField,
    PlaceSelect,
    ToCountrySelect,
    FromShipmentPointSelect,
  },
})
export default class CalculatorForm extends Vue {
  isShowDimensionsAndPrices = false

  get errors() {
    return CalculateStore.errors
  }

  get hasErrors(): boolean {
    return Object.keys(this.errors).length > 0
  }

  get country(): Country | null {
    return CalculateStore.country
  }

  get countryHasPlaces(): boolean {
    return this.country ? this.country.citiesCount > 0 : false
  }

  get isDisabledPlaceSelect(): boolean {
    return this.country === null || !this.countryHasPlaces
  }

  @Emit()
  submit() {
    return true
  }
}
